import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { List } from "immutable";
import { SubSink } from "subsink";
import { ListItem } from "../../../../../shared/list/list-item";
import { DateHelper } from "../../../../../utilities/contracts/date-helper";
import { MemberDetail } from "../member-detail.model";
import { MemberStateService } from "../member-state.service";

@Component({
  selector: "member-member-detail-header",
  templateUrl: "./member-detail-header.component.html",
  styleUrls: ["./member-detail-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberDetailHeaderComponent implements OnInit, OnDestroy {
  private sink = new SubSink();
  @Input() useCustomerId = false;
  memberDetail: MemberDetail;

  constructor(
    private memberStateService: MemberStateService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.sink.add(
      this.memberStateService.state.subscribe(state => {
        this.memberDetail = state;
        this.changeDetector.markForCheck();
      })
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
  }

  get memberItems(): List<ListItem> {
    const memberKeys = ["DOB:", "Gender:", "Member Index:", "Customer Member ID:"];

    const memberIndex =
      this.memberDetail.masterMemberId ??
      this.memberDetail.memberId ??
      "";

    const list = [
      new ListItem({
      key: "DOB:",
      value: this.memberDetail?.memberDateOfBirth?.includes("T") ? DateHelper.format(this.memberDetail.memberDateOfBirth) : (this.memberDetail?.memberDateOfBirth || ""),
      }),
      new ListItem({
      key: "Gender:",
      value: this.memberDetail.memberGender,
      }),
      new ListItem({
      key: this.useCustomerId ? "Customer Member ID:" : "Member Index:",
      value: memberIndex.toString(),
      }),
    ];

    const memberItems = list
      .filter(item => memberKeys.includes(item.key))
      .sort((a, b) => {
        const aValue = memberKeys.findIndex(key => key === a.key);
        const bValue = memberKeys.findIndex(key => key === b.key);
        return aValue - bValue;
      });

    return List(memberItems);
  }

}
